import { Switch } from '@syncfusion/ej2-buttons';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="taxReturnRequired"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement | null;

      if (!form || form.modelName?.value !== 'Individual') {
        return;
      }

      const taxReturnRequiredSwitch = getControl(editable.id) as Switch | undefined;
      const mtdItSection = form.querySelector('[data-individual-mtd-it-section="true"]') as HTMLElement | null;

      if (!taxReturnRequiredSwitch || !mtdItSection) {
        return;
      }

      const refresh = () => {
        mtdItSection.classList.toggle('d-none', !taxReturnRequiredSwitch.checked);
      };

      refresh();

      taxReturnRequiredSwitch.addEventListener('change', refresh);
    });
});
